export const SET_PASO = 'SET_PASO';
export const GET_PASO = 'GET_PASO';

export const REINICIAR = 'REINICIAR';

export const SET_AUTORIZACION_VIAJE = 'SET_AUTORIZACION_VIAJE';
export const SET_AUTORIZACION_TRABAJO_MENOR = 'SET_AUTORIZACION_TRABAJO_MENOR';
export const AGREGAR_PERSONA = 'AGREGAR_PERSONA';
export const SET_PERSONAS = 'SET_PERSONAS';
export const ELIMINAR_PERSONA = 'ELIMINAR_PERSONA';
export const GET_PERSONAS = 'GET_PERSONAS';

export const SET_CARGA_PERSONAS = 'SET_CARGA_PERSONAS';
export const SET_CARGA_CONTRAVENTORES = 'SET_CARGA_CONTRAVENTORES';

export const CAMBIAR_ROL = 'CAMBIAR_ROL';
export const CAMBIAR_ROL_POR_INDICE = 'CAMBIAR_ROL_POR_INDICE';

export const AGREGAR_CONTRAVENTOR = 'AGREGAR_CONTRAVENTOR';
export const ELIMINAR_CONTRAVENTOR = 'ELIMINAR_CONTRAVENTOR';
export const PRUEBA_CONTRAVENTOR = 'PRUEBA_CONTRAVENTOR';
export const SET_CONTRAVENTORES = 'SET_CONTRAVENTORES';
export const GET_CONTRAVENTORES = 'GET_CONTRAVENTORES';
export const UPDATE_ESTADO_EXPEDIENTE = 'GET_CONTRAVENTORES';
export const SET_EXPEDIENTE = 'SET_EXPEDIENTE';
export const ADD_ACTUACION = 'ADD_ACTUACION';
export const ADD_RECIBO = 'ADD_RECIBO';
export const UPDATE_ACTUACION = 'UPDATE_ACTUACION';
export const SET_PEDIDO = 'SET_PEDIDO';
export const UPDATE_CONTRAVENTOR_EXPEDIENTE = 'UPDATE_CONTRAVENTOR_EXPEDIENTE';
export const SET_VER_PEDIDO_ENVIO = 'SET_VER_PEDIDO_ENVIO';
export const SET_VER_DEPOSITO_CONTRAVENCION = 'SET_VER_DEPOSITO_CONTRAVENCION';
export const REINICIAR_PEDIDO = 'REINICIAR_PEDIDO';

export const SET_FILTROS = 'SET_FILTROS';

export const AGREGAR_DETALLE = 'AGREGAR_DETALLE';
export const AGREGAR_DETALLES = 'AGREGAR_DETALLES';
export const GET_DETALLES = 'GET_DETALLES';
export const ELIMINAR_DETALLE = 'ELIMINAR_DETALLE';
export const SET_DETALLES = 'SET_DETALLES';

//KEYCLOACK
export const AUTH_LOGIN_START = 'AUTH_LOGIN_START';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHECK_PUBLIC_ROUTE = 'AUTH_CHECK_PUBLIC_ROUTE';
export const AUTH_RESET_LOGIN_STATE = 'AUTH_RESET_LOGIN_STATE';
